import httpService from '@/api/http';
import { LOADING_KEY } from '@/util/constants';

/**
 * @since 3.18
 * @see {@link https://documenter.getpostman.com/view/3171682/RzfZNY7x?version=latest#5439db84-da7c-43be-9803-71f0ae51ad9f}
 *
 * @param context
 * @param loadingKey
 * @param term
 * @param nextId
 * @param nextValue
 * @param sortBy
 * @param filters
 * @param limit
 * @param token
 * @returns {Promise<AxiosResponse<any>>}
 */
function publicVenueFetchProducts(
  context,
  {
    loadingKey = LOADING_KEY.FETCH_PRODUCTS,
    term = undefined,
    nextId = undefined,
    sortBy = undefined,
    nextValue = undefined,
    filters = {},
    limit = 25,
    token = null,
  },
) {
  return httpService.get(`/public/venue/products`, {
    headers: { loadingKey, ...(token ? { 'X-Public-Token': token } : {}) },
    params: {
      term,
      nextValue,
      nextId,
      sortBy,
      limit,
      ...filters,
    },
  });
}

/**
 * @since 3.18
 * @see {@link https://documenter.getpostman.com/view/3171682/RzfZNY7x?version=latest#000eed1d-c46f-4a1a-ab3a-11274c218db6}
 *
 * @param context
 * @param id
 * @param loadingKey
 * @param token
 * @returns {Promise<AxiosResponse<any>>}
 */
function publicVenueFetchProduct(
  context,
  { id, token = null, loadingKey = LOADING_KEY.FETCH_PRODUCT },
) {
  return httpService.get(`/public/venue/products/${id}`, {
    headers: { loadingKey, ...(token ? { 'X-Public-Token': token } : {}) },
  });
}

export default {
  publicVenueFetchProducts,
  publicVenueFetchProduct,
};
